import React, { useEffect } from "react";
import FileInfo from './FileInfo';
import { CircularProgress } from "@material-ui/core";
import "../Projects/Project/project.css";
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllFiles } from '../../../../actions/projectActions';
import { useParams } from "react-router-dom";

const Files = () => {
    const dispatch = useDispatch();
    const { folderId } = useParams();

    const fileDelete = useSelector(state => state.fileDelete);
    const { afterDelete } = fileDelete;

    const allFiles = useSelector(state => state.allFiles);
    const { loading, error, allFileDetails } = allFiles;

    const fileRename = useSelector(state => state.fileRename);
    const { renameFileInfo } = fileRename;

    const fileDuplicate = useSelector(state => state.fileDuplicate);
    const { duplicateFileInfo } = fileDuplicate;

    const fileMove = useSelector(state => state.fileMove);
    const { moveFileInfo } = fileMove;

    useEffect(() => {
        if (folderId) {
            console.log(folderId);
            dispatch(fetchAllFiles(folderId));
        }
    }, [folderId, dispatch, , renameFileInfo, duplicateFileInfo, moveFileInfo, afterDelete]);

    return (
        <div className="project">
            <div className="mainlayout__taskbar">
                <h1>Project Files</h1>
            </div>
            <div className="projectbody">
                {loading ? <CircularProgress /> : error ? <h4>{error}</h4> :
                    (allFileDetails?.map(item => (
                        <FileInfo key={item._id} name={item.name} fileData={item} />
                    ))
                    )
                }
                {/* // <ProjectTabs name={"Project 1"} />
                // <ProjectTabs name={"Project 2"} />
                // <ProjectTabs name={"Project 3"} />
                // <ProjectTabs name={"Project 4"} /> */}
            </div>
        </div>
    )
}

export default Files
